export async function faq() {
  // select expand all button on FAQ
  let expandFAQ = document.getElementById('expand-all');

  expandFAQ.addEventListener('click', function (e) {
    // add open attr to each details tag
    let details = document.querySelectorAll('details');

    // check expandFAQ class
    let ifOpen = expandFAQ.classList.contains('expanded');

    details.forEach((d) => {
      ifOpen ? d.removeAttribute('open') : d.setAttribute('open', true);
    });

    // toggle "expanded" class
    expandFAQ.classList.toggle('expanded');

    // if expanded, change text to "Collapse all"
    ifOpen
      ? (expandFAQ.innerHTML = `Expand all`)
      : (expandFAQ.innerHTML = `Collapse all`);
  });
}
